import { produce } from 'immer'
import { ReportDownloadListResponse } from 'src/models/reportDownload.models'
import {
  CLEAR_TOP_LEVEL_ERROR_EXPENSE_REPORTS,
  ClearTopLevelErrorExpenseReportsAction,
  GET_REPORT_DOWNLOAD_FAILURE,
  GET_REPORT_DOWNLOAD_INIT,
  GET_REPORT_DOWNLOAD_SUCCESS,
  GetReportDownloadActions,
  POST_EXPENSE_REPORT_DOWNLOAD_FAILURE,
  POST_EXPENSE_REPORT_DOWNLOAD_INIT,
  POST_EXPENSE_REPORT_DOWNLOAD_SUCCESS,
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_FAILURE,
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_INIT,
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_SUCCESS,
  POST_PEOPLE_DOWNLOAD_FAILURE,
  POST_PEOPLE_DOWNLOAD_INIT,
  POST_PEOPLE_DOWNLOAD_SUCCESS,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_FAILURE,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_INIT,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_SUCCESS,
  POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_FAILURE,
  POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_INIT,
  POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_SUCCESS,
  PostExpenseReportDownloadActions,
  PostOrgExpenseReportDownloadActions,
  PostPeopleDownloadActions,
  PostReportTransactionsDownloadActions,
  PostReportVirtualCardsDownloadActions,
} from 'src/redux/actions/data/reportDownloads.actions'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface ReportDownloadsState {
  loading: boolean
  listResponses: Record<string, ReportDownloadListResponse>
  topLevelError?: string
}

export const initialState: ReportDownloadsState = {
  loading: false,
  listResponses: {},
}

export type Actions =
  | PostReportTransactionsDownloadActions
  | GetReportDownloadActions
  | PostReportVirtualCardsDownloadActions
  | PostPeopleDownloadActions
  | PostExpenseReportDownloadActions
  | PostOrgExpenseReportDownloadActions
  | ClearTopLevelErrorExpenseReportsAction

const ReportDownloadsReducer = (
  state: ReportDownloadsState = initialState,
  action: Actions,
): ReportDownloadsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_EXPENSE_REPORT_DOWNLOAD_INIT:
      case POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_INIT:
      case POST_REPORT_TRANSACTIONS_DOWNLOAD_INIT:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_INIT:
      case POST_PEOPLE_DOWNLOAD_INIT:
      case GET_REPORT_DOWNLOAD_INIT: {
        draft.loading = true
        draft.topLevelError = undefined
        return draft
      }

      case POST_EXPENSE_REPORT_DOWNLOAD_SUCCESS:
      case POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_SUCCESS:
      case POST_REPORT_TRANSACTIONS_DOWNLOAD_SUCCESS:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_SUCCESS:
      case POST_PEOPLE_DOWNLOAD_SUCCESS:
      case GET_REPORT_DOWNLOAD_SUCCESS: {
        draft.loading = false
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.reportDownload.id]: action.payload.reportDownload,
        }
        return draft
      }

      case POST_EXPENSE_REPORT_DOWNLOAD_FAILURE:
      case POST_REPORT_VIRTUAL_CARDS_DOWNLOAD_FAILURE:
      case POST_REPORT_TRANSACTIONS_DOWNLOAD_FAILURE:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_FAILURE:
      case POST_PEOPLE_DOWNLOAD_FAILURE:
      case GET_REPORT_DOWNLOAD_FAILURE: {
        draft.loading = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        return draft
      }

      case CLEAR_TOP_LEVEL_ERROR_EXPENSE_REPORTS: {
        draft.topLevelError = undefined
      }
    }
  })
}

export default ReportDownloadsReducer
